import { useCallback } from 'react';

import {
  FilterRestaurantType,
  IRestaurantsInput,
  useGetRestaurantsLazyQuery,
} from 'generated/rbi-graphql';
import { withLazySimpleCache } from 'state/graphql/with-simple-cache';

interface IFetchRestaurantsOptions {
  allowFromCache: boolean;
}

const useCachedGetRestaurantsLazyQuery = withLazySimpleCache(useGetRestaurantsLazyQuery);

export const useRestaurants = (filter: FilterRestaurantType) => {
  const [fetchRestaurants, { data, loading, error }] = useCachedGetRestaurantsLazyQuery();

  const fetch = useCallback(
    (
      input: IRestaurantsInput = {},
      options: IFetchRestaurantsOptions = { allowFromCache: true }
    ) => {
      fetchRestaurants({
        allowFromCache: options.allowFromCache,
        variables: { input: { filter, ...input } },
      });
    },
    [fetchRestaurants, filter]
  );

  return { fetch, data, loading, error };
};
